import { DeleteOutlined, PoweroffOutlined } from "@ant-design/icons";
import { Button, Modal, Tag, message } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { ZupRole } from "../../features/integration-setting-table/RolesTable/role.type";
import { useLazyGetZupRolesQuery, useRemoveZupRoleMutation, usePatchZupRoleMutation } from "../../store/api/roleApi";

export const OneCZupRolePage = () => {
    const [searchParams, setSearchParams] = useState({
        page_number: 1,
        page_size: 10,
    });

    const [getZupRoles, { data, isLoading }] = useLazyGetZupRolesQuery();
    const [removeZupRole] = useRemoveZupRoleMutation();
    const [patchZupRole] = usePatchZupRoleMutation();

    const [searchText, setSearchText] = useState<Record<string, string>>({});

    useEffect(() => {
        getZupRoles(searchParams);
    }, [searchParams]);

    const handleDelete = (id: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите удалить эту роль?',
            content: 'Это действие нельзя отменить.',
            okText: 'Да',
            okType: 'danger',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await removeZupRole(id).unwrap();
                    message.success('Роль успешно удалена');
                    getZupRoles(searchParams);
                } catch (error) {
                    message.error('Не удалось удалить роль');
                }
            },
        });
    };

    const handleEnable = (id: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите активировать эту роль?',
            content: 'Роль будет активирована в системе.',
            okText: 'Да',
            okType: 'primary',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await patchZupRole({ id }).unwrap();
                    message.success('Роль успешно активирована');
                    getZupRoles(searchParams);
                } catch (error) {
                    message.error('Не удалось активировать роль');
                }
            },
        });
    };

    const columns: ColumnsType<ZupRole> = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            filterSearch: true,
            filters: data?.data.content.map((item) => ({
                text: item.name.toString(),
                value: item.id.toString(),
            })),
            filteredValue: searchText.name ? [searchText.name] : null,
            onFilter: (value, record) => record.name.toLowerCase().includes(value.toString().toLowerCase()),
        },
        {
            title: 'Статус',
            dataIndex: 'enabled',
            key: 'enabled',
            render: (enabled: boolean) => (
                <Tag color={enabled ? 'green' : 'red'}>
                    {enabled ? 'Включен' : 'Отключен'}
                </Tag>
            ),
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_, record) => (
                <>
                    {
                        record.enabled ?
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => handleDelete(record.id)}
                                style={{ marginRight: 8 }}
                            />
                            :
                            <Button
                                type="primary"
                                icon={<PoweroffOutlined />}
                                onClick={() => handleEnable(record.id)}
                            />
                    }

                </>
            ),
        },
    ];

    return (
        <div>
            <h1>Роли 1C ЗУП</h1>
            <Table
                columns={columns}
                dataSource={data?.data.content}
                loading={isLoading}
                bordered
                pagination={{
                    current: searchParams.page_number,
                    pageSize: searchParams.page_size,
                    total: data?.data.total_elements,
                    onChange: (page, pageSize) => {
                        setSearchParams({
                            page_number: page,
                            page_size: pageSize,
                        });
                    },
                    showSizeChanger: true,
                    showQuickJumper: true,
                }}
                rowKey="id"
            />
        </div>
    );
};
